import { EnumConfig } from 'angular-odata';

//#region ODataApi Imports
import { RefType } from './reftype.enum';
//#endregion

export const RefTypeConfig = {
  name: "RefType",
  members: RefType
} as EnumConfig<RefType>;